// extracted by mini-css-extract-plugin
export default {"delete-button":"events-contributions-client-js-___MyTimetable-module__delete-button___brDTj"};